import createReducer from "./reducerUtils";
import {
  LOADING_PROCESAR_PAGO,
  LOADING_CALCULAR_ITF,
  LOADING_DISPONIBILIDAD_PAGO,
  DISPONIBILIDAD_PAGO,
  LOADING_VALIDAR_PROGRAMA_ESTADO,
  VALIDACION_PROGRAMA_ESTADO,
  MSG_ERROR_SERVICIO_NO_DISPONIBLE,
} from "../actions/actionTypes";

const initialState = {
  loadingProcesarPago: false,
  loadingCalcularItf: false,
  loadingDisponibilidadPago: false,
  disponibilidadPago: false,
  validacionProgramaEstado: null,
  loadingValidarProgramaEstado: false,
  msgErrorServicioNoDisponible: null,
};

const loadingProcesarPago = (state, payload) => {
  return { ...state, loadingProcesarPago: payload.loading };
};

const loadingCalcularItf = (state, payload) => {
  return { ...state, loadingCalcularItf: payload.loading };
};

const loadingDisponibilidadPago = (state, payload) => {
  return { ...state, loadingDisponibilidadPago: payload.loading };
};

const disponibilidadPago = (state, payload) => {
  return { ...state, disponibilidadPago: payload.disponibilidadPago };
};

const msgErrorServicioNoDisponible = (state, payload) => {
  return {
    ...state,
    msgErrorServicioNoDisponible: payload.msgErrorServicioNoDisponible,
  };
};

const loadingValidarProgramaEstado = (state, payload) => {
  return { ...state, loadingValidarProgramaEstado: payload.loading };
};

const validacionProgramaEstado = (state, payload) => {
  return {
    ...state,
    validacionProgramaEstado: payload.validacionProgramaEstado,
  };
};

export default createReducer(initialState, {
  [LOADING_PROCESAR_PAGO]: loadingProcesarPago,
  [LOADING_CALCULAR_ITF]: loadingCalcularItf,
  [LOADING_DISPONIBILIDAD_PAGO]: loadingDisponibilidadPago,
  [DISPONIBILIDAD_PAGO]: disponibilidadPago,
  [MSG_ERROR_SERVICIO_NO_DISPONIBLE]: msgErrorServicioNoDisponible,
  [VALIDACION_PROGRAMA_ESTADO]: validacionProgramaEstado,
  [LOADING_VALIDAR_PROGRAMA_ESTADO]: loadingValidarProgramaEstado,
});
